module.exports = {
    config: {
        isCacheable: false // prevents initial ticker flicker from last cached timestamp to actual one.
    }
}